// src/utils/formatters.ts
// ============================================================
// Summit League v2 — Shared formatting utilities
// ============================================================

/**
 * Format a date string as a human-readable relative time.
 * e.g. "Just now", "5m ago", "3h ago", "Yesterday", "2d ago", "1w ago",
 * or falls back to short date like "Jan 15".
 */
export function formatRelativeTime(dateStr: string): string {
  const now = Date.now();
  const then = new Date(dateStr).getTime();
  const diffSec = Math.floor((now - then) / 1000);

  if (diffSec < 60) return 'Just now';

  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return `${diffMin}m ago`;

  const diffHr = Math.floor(diffMin / 60);
  if (diffHr < 24) return `${diffHr}h ago`;

  const diffDay = Math.floor(diffHr / 24);
  if (diffDay === 1) return 'Yesterday';
  if (diffDay < 7) return `${diffDay}d ago`;

  const diffWeek = Math.floor(diffDay / 7);
  if (diffWeek < 4) return `${diffWeek}w ago`;

  // Fallback: short date
  return new Date(dateStr).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
  });
}

/**
 * Extract a user-friendly error message from an Axios error response.
 * Checks `error` field first (backend primary), then `message`, then
 * the JS error message, finally a fallback string.
 */
export function extractError(err: any, fallback = 'Something went wrong'): string {
  return err?.response?.data?.error || err?.response?.data?.message || err?.message || fallback;
}
